import React from 'react';
import { Route } from '../Routing/types';
import {
  PATH_TRACKER,
  PATH_TRACKER_SETTINGS,
  PATH_TRACKER_SETTINGS_MACRO,
  PATH_TRACKER_MEAL,
  PATH_TRACKER_EDIT_MEAL,
  PATH_TRACKER_ADD_INGREDIENT,
  PATH_TRACKER_DESCRIBE_MEAL,
  PATH_TRACKER_DESCRIBE_MEAL_MEAL,
  PATH_TRACKER_DESCRIBE_MEAL_EDIT,
  PATH_TRACKER_DESCRIBE_ADD_INGREDIENT,
  PATH_TRACKER_DESCRIBE_MEAL_VOICE,
} from './paths';
import { DIET_TYPES } from '../GoalSettings/consts';
import {
  TrackerIndexPage,
  TrackerSettingsPage,
  MacroSettingsPage,
  TrackerMealPage,
  TrackerEditMealPage,
  TrackerAddIngredientPage,
  TrackerDescribeMealPage,
  TrackerAddDescribeMealPage,
  TrackerEditDescribePage,
  TrackerDescribeMealVoicePage,
} from '@front-activerse/modules';
import { trackerArticleId } from './consts';
import { fetchRemoteConfigFields } from '../Firebase/firebaseRemoteConfig';
import { markNotificationAsClosed, getClosedNotifications } from '../Firebase/firebaseFirestoreDb';

const dummy_t = (translationKey: string) => translationKey;

const descendantRoutes: Route[] = [
  {
    path: PATH_TRACKER,
    element: (
      <TrackerIndexPage
        trackerArticleId={trackerArticleId}
        fetchRemoteConfigFields={fetchRemoteConfigFields}
        getClosedNotifications={getClosedNotifications}
        markNotificationAsClosed={markNotificationAsClosed}
      />
    ),
    private: true,
    title: dummy_t('tracker.details.navbarTitle'),
    mobileAppTabIdentifier: '',
  },
  {
    path: PATH_TRACKER_SETTINGS,
    element: <TrackerSettingsPage dietTypes={DIET_TYPES} />,
    private: true,
    title: dummy_t('trackerSettings.navbarTitle'),
    mobileAppTabIdentifier: '',
  },
  {
    path: PATH_TRACKER_SETTINGS_MACRO,
    element: <MacroSettingsPage />,
    private: true,
    title: dummy_t('tracker.macroSettings.navbarTitile'),
    mobileAppTabIdentifier: '',
  },
  {
    path: PATH_TRACKER_MEAL,
    element: <TrackerMealPage />,
    private: true,
    title: 'tracker.logMeal.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_EDIT_MEAL,
    element: <TrackerEditMealPage />,
    private: true,
    title: 'tracker.logMeal.ingredients.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_ADD_INGREDIENT,
    element: <TrackerAddIngredientPage />,
    private: true,
    title: 'tracker.logMeal.addIngredient.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_DESCRIBE_MEAL,
    element: <TrackerDescribeMealPage />,
    private: true,
    title: 'tracker.describeFood.navbar.Title',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_DESCRIBE_MEAL_VOICE,
    element: <TrackerDescribeMealVoicePage />,
    private: true,
    title: 'tracker.describeFood.byVoice.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_DESCRIBE_MEAL_EDIT,
    element: <TrackerEditDescribePage />,
    private: true,
    title: 'tracker.logMeal.ingredients.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_DESCRIBE_ADD_INGREDIENT,
    element: <TrackerAddIngredientPage />,
    private: true,
    title: 'tracker.logMeal.addIngredient.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_DESCRIBE_MEAL_MEAL,
    element: <TrackerAddDescribeMealPage />,
    private: true,
    title: 'tracker.logMeal.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
];

export default descendantRoutes;
